import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ChevronRightIcon } from '../../atoms/material-icons';
import { BQLink } from '../../atoms/bqlink';
import { useInView } from 'react-intersection-observer';
import { formatNumbers } from '../../../helpers/utils';

import './ndtv-market-widget.m.css';

const NdtvMarketWidget = (props) => {
  const queryClient = new QueryClient();
  const [currentIndicesValues, setCurrentIndicesValues] = useState([]);
  const [initialCall, setInitialCall] = useState(true);
  const [darkMode, setDarkMode] = useState(false);
  const [isDailyHuntWidget, setIsDailyHuntWidget] = useState(false);
  const [ref, inView] = useInView();

  const getIndicesData = async () => {
    const url = 'https://d9rnhtfx340tw.cloudfront.net/getIndices';
    try {
      const res = await makeApiCall(url);
      setCurrentIndicesValues(res);
    } catch (e) {
      setCurrentIndicesValues([]);
    }
  };

  const makeApiCall = async (url) => {
    try {
      const response = await fetch(url);
      return await response.json();
    } catch (error) {
      console.error('error = ' + error);
      return [];
    }
  };

  useEffect(() => {
    if (inView) {
      if (initialCall) {
        getIndicesData();
        setInitialCall(false);
      } else {
        const timer = setInterval(() => {
          getIndicesData();
        }, 30000);
        return () => clearInterval(timer);
      }
    }
  });

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const dm = urlParams.get('dm');
    const client = urlParams.get('client');

    if (client && client === 'dh') {
      setIsDailyHuntWidget(true);
    }

    if (dm == 1) {
      setDarkMode(true);
    } else {
      setDarkMode(false);
    }
  }, []);

  const createIndiceBox = (loading) => (
    <>
      {Array.apply(null, Array(2)).map((value, index) => (
        <BQLink
          href={
            'https://www.ndtvprofit.com/markets?utm_source=ndtv&utm_medium=referral&utm_campaign=np_elec'
          }
          target="_blank"
        >
          <div styleName="indice-box">
            <div styleName="indices">
              {!loading ? (
                <React.Fragment>
                  {(currentIndicesValues[index].change === 0 ||
                    currentIndicesValues[index].change > 0) && (
                    <div styleName="positive-icon"></div>
                  )}
                  {currentIndicesValues[index].change < 0 && <div styleName="negative-icon"></div>}
                  <div styleName="indices-ctx">
                    <div styleName="title-ctx">
                      <span styleName="indice-title">{currentIndicesValues[index].name}</span>
                      <span styleName="latest-price">
                        {formatNumbers(currentIndicesValues[index].lastPrice, false)}
                      </span>
                    </div>
                    <div styleName="price-ctx">
                      <span
                        styleName={`change-price ${currentIndicesValues[index].change === 0 || currentIndicesValues[index].change > 0 ? 'positive' : 'negative'}`}
                      >
                        {formatNumbers(currentIndicesValues[index].change, true)}
                      </span>
                      <span
                        styleName={`change-perc ${currentIndicesValues[index].change === 0 || currentIndicesValues[index].change > 0 ? 'positive' : 'negative'}`}
                      >
                        {currentIndicesValues[index].changePer.toFixed(2)}%
                      </span>
                    </div>
                  </div>
                  <div styleName="arrow">
                    <ChevronRightIcon size="28px" />
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div styleName="loading-shimmer-image">
                    <img src="/icons/image_loading_icon.svg" alt="Loading Icon" />
                  </div>
                  <div styleName="loading-shimmer-ctx">
                    <div styleName="loading-shimmer-title-ctx">
                      <div styleName="loading-shimmer-name"></div>
                      <div styleName="loading-shimmer-current"></div>
                    </div>
                    <div styleName="loading-shimmer-price-ctx">
                      <div styleName="loading-shimmer-change"></div>
                      <div styleName="loading-shimmer-change-perc"></div>
                    </div>
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </BQLink>
      ))}
    </>
  );

  const createWidget = () => {
    return (
      <div
        ref={ref}
        styleName={`widget-ctx ${darkMode ? 'dark-mode' : 'light-mode'} ${isDailyHuntWidget ? 'dh-widget' : ''}`}
      >
        {isDailyHuntWidget && (
          <div styleName="first-row">
            <BQLink
              href={
                'https://www.ndtvprofit.com/markets?utm_source=ndtv&utm_medium=referral&utm_campaign=np_elec'
              }
              target="_blank"
            >
              <div styleName="title-and-image">
                <span styleName="title">Markets</span>
                <span styleName="right-icon">
                  <ChevronRightIcon size="18px" />
                </span>
              </div>
            </BQLink>
            <BQLink
              href={
                'https://www.ndtvprofit.com?utm_source=ndtv&utm_medium=referral&utm_campaign=np_elec'
              }
              target="_blank"
            >
              <div styleName="powered-by">
                <span styleName="title">Powered by</span>
                <div styleName="site-logo"></div>
              </div>
            </BQLink>
          </div>
        )}
        <div styleName="second-row">
          {currentIndicesValues.length > 0 ? (
            <React.Fragment>{createIndiceBox(false)}</React.Fragment>
          ) : (
            <React.Fragment>{createIndiceBox(true)}</React.Fragment>
          )}
        </div>
      </div>
    );
  };

  return (
    <QueryClientProvider client={queryClient}>
      <React.Fragment>{createWidget()}</React.Fragment>
    </QueryClientProvider>
  );
};

export { NdtvMarketWidget };
